import axios from '@axios'
import { useApiAWS } from '@/composables/useApi'

const apiAws = useApiAWS()

export default {
  namespaced: true,
  state: {
    item: {
      item_nome: '',
      item_descricao: 'F',
      id_categoria: '',
      ativo: null,
      imagens: [],
    },
    items: [],
    isProcessingImages: false,
  },
  getters: {
    GET_ITEMS(state) {
      return state.items
    },
    GET_IMAGENS_ITEM(state) {
      return state.item.imagens
    },
    GET_IS_PROCESSING_IMAGES(state) {
      return state.isProcessingImages
    },
  },
  mutations: {
    SET_PRODUTO_DATA(state, cliente) {
      state.cliente = cliente
    },
    SET_IMAGE_PRODUTO_DATA(state, image) {
      state.item.imagens.push(image)
    },
    REMOVE_IMAGE_PRODUTO_DATA(state, iamge) {
      const index = state.item.imagens.indexOf(iamge)
      state.item.imagens.splice(index, 1)
    },
    SET_ITEM_DATA(state, item) {
      state.item = item
    },
    SET_IS_PROCESSING_IMAGES(state, isProcessing) {
      state.isProcessingImages = isProcessing
    },
  },
  actions: {
    createImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/imagens', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    createVariasImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/imagens/variasImagens', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    uploadImages(ctx, { formData }) {
      return new Promise((resolve, reject) => {
        apiAws
          .post('/upload', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/items', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    countAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/items/count', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    findAllbyVendedor(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        const idVendedor = queryParams.id_vendedor
        const { id_vendedor, ...paramsParaQuery } = queryParams

        axios
          .get(`/items/vendedor/${idVendedor}`, { params: paramsParaQuery })
          .then(response => resolve(response))
          .catch(error => {
            const errorMessage = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Erro ao buscar itens por vendedor.'
            reject(errorMessage)
          })
      })
    },
    save(ctx, clienteData) {
      return new Promise((resolve, reject) => {
        const { id_tabela_preco, preco_venda, ...formData } = clienteData
        axios.post('/items/save', formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    update(ctx, clienteData) {
      return new Promise((resolve, reject) => {
        const { id_tabela_preco, preco_venda, ...formData } = clienteData
        axios.put(`/items/${formData.id}`, formData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/items/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/items/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    create(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/items', categoryData)
          .then(response => resolve(response))
          .catch(error => reject(error.response.data.message))
      })
    },
    clearItemData(ctx) {
      ctx.commit('SET_ITEM_DATA', {
        id: null,
        uuid: null,
        id_categoria: null,
        id_tabela_preco: null,
        item_nome: '',
        ativo: 1,
        item_descricao: '',
        preco_venda: '',
        imagens: [],
      })
    },
  },
}
